import React, { useCallback, useState } from "react";
import { withApollo } from "@apollo/react-hoc";
import Header from "../../components/organisms/header";
import {
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
} from "reactstrap";
import T from "../../components/atoms/translate";
import UpdateProfile from "../../components/templates/update-profile";
import Loading from "../../components/atoms/loading";
import API from "../../api/API";
import { CURRENT_USER, MY_PROFILE } from "../../api/user";
import { useEffect } from "react";
import { showToast, t } from "../../utils/utils";
import { Redirect } from "react-router-dom";
import ChangePassword from "../../components/templates/change-password";

const AccountPage = ({ client }) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [profileExists, setProfileExists] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const getProfile = useCallback(async () => {
    let user = {
      id: "",
      email: "",
      firstName: "",
      lastName: "",
      address: "",
      language: "",
    };
    try {
      const res = await API.query(client, CURRENT_USER, {});
      if (res && res.data && res.data.currentUser) {
        user.email = res.data.currentUser.email;
        user.language = res.data.currentUser.language;
      } else {
        showToast(t("errorAlObtenerPerfil"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorAlObtenerPerfil"), "error");
      } else {
        showToast(t("errorAlObtenerPerfil"), "error");
      }
      setRedirect(true);
    }
    try {
      const res = await API.query(client, MY_PROFILE, {});
      if (res && res.data && res.data.getCurrentProfile) {
        setProfileExists(true);
        user.id = res.data.getCurrentProfile.id;
        user.firstName = res.data.getCurrentProfile.name;
        user.lastName = res.data.getCurrentProfile.last_name;
        user.address = res.data.getCurrentProfile.address;
      } else {
        showToast(t("errorAlObtenerPerfil"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        if (
          graphQLErrors[0] &&
          graphQLErrors[0].message === "there is no profile"
        ) {
          setProfileExists(false);
        } else {
          showToast(graphQLErrors[0].message, "error");
        }
      } else if (networkError) {
        showToast(t("errorAlObtenerPerfil"), "error");
      } else {
        showToast(t("errorAlObtenerPerfil"), "error");
      }
    }
    setProfile(user);
    setLoading(false);
  }, [client]);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  if (redirect) return <Redirect to="/" />;
  return (
    <>
      <Header />
      <Container className="mt-4" style={{ height: "85vh" }}>
        <h1 className="text-primary">
          <T i18nKey="miCuenta" />
        </h1>
        <hr />

        <Row style={{ height: "80%" }}>
          <Col xs="12">
            <Card
              body
              className="h-100 box-shadow rounded-xg border-gris-100 generic-card"
            >
              <Row>
                <Col xs="12">
                  <Nav pills>
                    <NavItem>
                      <NavLink
                        className={`cursor-pointer ${
                          activeTab === "profile" ? "active" : ""
                        }`}
                        onClick={() => {
                          toggle("profile");
                        }}
                      >
                        <T i18nKey="perfil" />
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={`cursor-pointer ${
                          activeTab === "password" ? "active" : ""
                        }`}
                        onClick={() => {
                          toggle("password");
                        }}
                      >
                        <T i18nKey="password" />
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab} className="mt-3">
                    <TabPane tabId="profile">
                      <Row>
                        <Col xs="12">
                          {loading ? (
                            <Loading />
                          ) : (
                            <UpdateProfile
                              client={client}
                              profile={profile}
                              profileExists={profileExists}
                            />
                          )}
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="password">
                      <Row>
                        <Col xs="12">
                          {loading ? <Loading /> : <ChangePassword />}
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default withApollo(AccountPage);
